import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { END_LOADING, ERROR, FILTER, START_LOADING, UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';
import { resourcesService } from '@/main/services';

import { DMS_MODULE, NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
		NdprijemPzn: [],
	},
	filter: {
		Otevrena: null as null | boolean,
		UzavrenaKorNc: null as null | boolean,
		Uzavrena: null as null | boolean,
		Vyrazena: null as null | boolean,
		SkladOzn: null as null | number,
		PrijemkaPfx: null as null | string,
		PrijemkaNr: null as null | number,
		DodListNr: null as null | string,
		DodFaktNr: null as null | string,
		VstupDatOd: null as null | string,
		VstupDatDo: null as null | string,
		UzavreniDatOd: null as null | string,
		UzavreniDatDo: null as null | string,
		VstupPracId: null as null | number,
		VstupPracIdText: null as null | string,
		VstupPracOsobniCis: null as null | string,
		DodavatelId: null as null | number,
		DodavatelIdText: null as null | string,
		NdprijemPzn: null as null | number,
		MioId: null as number | null,
		MioText: null as string | null,
		PROrderId: null as null | number,
	},
	tableSetting: {},
	localState: {
		StatusPrijemky: null,
	},
	rowDetail: null,
	extraGetters: {},
	extraActions: {
		async [FILTER]({ commit, dispatch }) {
			try {
				commit(START_LOADING);
				const [resp, status] = await Promise.all(
					[apiProvider.filter(), resourcesService.loadTextLong('StatusPrijemky')],
				);
				commit(UPDATE_BASIC_FILTER, resp!.data);
				commit(listMutations.ND_PRIJEMKA_STATUS_PRIJEMKY, { status });
				return resp;
			} catch (err) {
				dispatch(ERROR, { DMS_MODULE, err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
	},
	extraMutations: {
		[listMutations.ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.DodavatelId = data.value;
			state.filter.DodavatelIdText = data.text;
		},
		[listMutations.ND_PRIJEMKA_NDOBJEDNAVKA_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.MioId = data.value;
			state.filter.MioText = data.text;
		},
		[listMutations.ND_PRIJEMKA_VSTUP_PRAC_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
		[listMutations.ND_PRIJEMKA_STATUS_PRIJEMKY](state, { status }) {
			state.localState.StatusPrijemky = status.replace(/"/g, '').split(',');
		},
		[listMutations.ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER](state, { data }) {
			state.filter.PROrderId = data.value;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
